import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import useNotify from "hooks/useNotify";
import { actions } from "store/actions";
import profileApi from "api/profile";
import { scrollIntoView } from "utils/helper";

function useContactDetails() {
  const dispatch = useDispatch();
  const userDetails = useSelector((state) => state.userDetails || {});
  const [isLoading, setIsLoading] = useState(false);
  const { notifyError, notifySuccess } = useNotify();

  const onEditContactDetails = async (values) => {
    try {
      setIsLoading(true);

      const payload = { contacts: values.contacts };

      await profileApi.updateAgencyContactDetails(userDetails?.agencyId, payload);

      dispatch(actions.setUserDetails({ ...userDetails, contacts: values.contacts }));

      notifySuccess("Has been updated successfully");
      scrollIntoView("contactDetailsSection");
    } catch (err) {
      console.error(err);
      notifyError(err?.data?.error ?? err?.message ?? "Something went wrong!");
    } finally {
      setIsLoading(false);
    }
  };

  const resetOnUnmount = () => {};
  useEffect(() => {
    return () => {
      resetOnUnmount();
    };
  }, []);

  return { onEditContactDetails, isLoading };
}

export default useContactDetails;

